// import React, { useEffect, useState, useMemo } from "react";
// import DoctorHeader from "./DoctorHeader";
// import DoctorSidebar from "./DoctorSidebar";
// import DoctorFooter from "./DoctorFooter";
// import { Drawer, InputBase, IconButton } from "@mui/material";
// import { Menu } from "lucide-react";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import SimpleSnackbar from "../Snackbar";

// const PharmacyDashboard = () => {
//   const { pharmId } = useParams();

//   const [editingIndex, setEditingIndex] = useState(null);
// const [editDrug, setEditDrug] = useState(null);


//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [pharmacy, setPharmacy] = useState(null);

//   const [snackMessage, setSnackMessage] = useState("");
//   const [snackColor, setSnackColor] = useState("success");

//   const [drug, setDrug] = useState({
//     genericName: "",
//     brandName: "",
//     tags: "",
//     price: "",
//     description: "",
//   });

//   const [activeSuggest, setActiveSuggest] = useState(null);

//   /* ---------------- FETCH ---------------- */
//   const fetchPharmacy = async () => {
//     const res = await axios.get(
//       `${process.env.REACT_APP_BACKEND_URL}/pharmacy/${pharmId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     );

//     setPharmacy(res.data.pharmacy);
//   };

//   useEffect(() => {
//     fetchPharmacy();
//   }, []);

//   /* ---------------- FORMATTERS ---------------- */
//   const formatPrice = (value) => {
//     const numeric = value.replace(/[^\d]/g, "");
//     if (!numeric) return "";
//     return "₦" + Number(numeric).toLocaleString();
//   };

//   const parsePrice = (value) => {
//     return Number(value.replace(/[^\d]/g, ""));
//   };

//   /* ---------------- AUTOSUGGEST ---------------- */
//   const allDrugNames = useMemo(() => {
//     if (!pharmacy?.drugs) return [];

//     const names = [];

//     pharmacy.drugs.forEach((d) => {
//       if (d.genericName) names.push(d.genericName);
//       if (d.brandName) names.push(d.brandName);
//     });

//     return [...new Set(names)];
//   }, [pharmacy]);

//   const getSuggestions = (value) => {
//     if (!value) return [];
//     return allDrugNames.filter((n) =>
//       n.toLowerCase().includes(value.toLowerCase())
//     ).slice(0, 5);
//   };

//   /* ---------------- ACTIONS ---------------- */
//   const handleSave = async () => {
//     try {
//       setLoading(true);
//       setSnackMessage("Saving changes...");
//       setSnackColor("info");

//       await axios.put(
//         `${process.env.REACT_APP_BACKEND_URL}/pharmacy/${pharmId}`,
//         {
//           ...pharmacy,
//           location: {
//             ...pharmacy.location,
//             lat: Number(pharmacy.location?.lat),
//             lng: Number(pharmacy.location?.lng),
//           },
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setSnackMessage("Updated successfully");
//       setSnackColor("success");
//     } catch {
//       setSnackMessage("Error updating pharmacy");
//       setSnackColor("error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const startEdit = (drug, index) => {
//     setEditingIndex(index);
//     setEditDrug({
//       ...drug,
//       price: "₦" + Number(drug.price).toLocaleString(),
//       tags: drug.tags?.join(", "),
//     });
//   };
  
//   const cancelEdit = () => {
//     setEditingIndex(null);
//     setEditDrug(null);
//   };
  
//   const updateDrug = async (drugId) => {
//     try {
//       setSnackMessage("Updating drug...");
//       setSnackColor("info");
  
//       await axios.put(
//         `${process.env.REACT_APP_BACKEND_URL}/pharmacy/${pharmId}/drugs/${drugId}`,
//         {
//           genericName: editDrug.genericName.toLowerCase(),
//           brandName: editDrug.brandName.toLowerCase(),
//           tags: editDrug.tags.split(",").map((t) => t.trim().toLowerCase()),
//           price: Number(editDrug.price.replace(/[^\d]/g, "")),
//           description: editDrug.description,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
  
//       setSnackMessage("Drug updated");
//       setSnackColor("success");
  
//       cancelEdit();
//       fetchPharmacy();
//     } catch {
//       setSnackMessage("Failed to update drug");
//       setSnackColor("error");
//     }
//   };
  
//   const deleteDrug = async (drugId) => {
//     try {
//       setSnackMessage("Removing drug...");
//       setSnackColor("info");
  
//       await axios.delete(
//         `${process.env.REACT_APP_BACKEND_URL}/pharmacy/${pharmId}/drugs/${drugId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
  
//       setSnackMessage("Drug removed");
//       setSnackColor("success");
  
//       fetchPharmacy();
//     } catch {
//       setSnackMessage("Failed to delete drug");
//       setSnackColor("error");
//     }
//   };
//   const addDrug = async () => {
//     try {
//       setSnackMessage("Adding drug...");
//       setSnackColor("info");

//       await axios.post(
//         `${process.env.REACT_APP_BACKEND_URL}/pharmacy/${pharmId}/drugs`,
//         {
//           genericName: drug.genericName.toLowerCase(),
//           brandName: drug.brandName.toLowerCase(),
//           tags: drug.tags.split(",").map((t) => t.trim().toLowerCase()),
//           price: parsePrice(drug.price),
//           description: drug.description,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setSnackMessage("Drug added successfully");
//       setSnackColor("success");

//       setDrug({
//         genericName: "",
//         brandName: "",
//         tags: "",
//         price: "",
//         description: "",
//       });

//       fetchPharmacy();
//     } catch {
//       setSnackMessage("Failed to add drug");
//       setSnackColor("error");
//     }
//   };

//   if (!pharmacy) return <p className="p-6">Loading...</p>;

//   return (
//     <div className="min-h-screen flex flex-col bg-[#F7F8F0]">
//       <DoctorHeader />

//       <div className="flex flex-1">
//         <div className="hidden lg:flex">
//           <DoctorSidebar activeTab="Pharmacy" setActiveTab={() => {}} />
//         </div>

//         <Drawer
//           anchor="left"
//           open={drawerOpen}
//           onClose={() => setDrawerOpen(false)}
//         >
//           <DoctorSidebar activeTab={'Pharmacy'} setActiveTab={() => {}} />
//         </Drawer>

//         <main className="flex-1 p-4 md:p-8 max-w-6xl mx-auto w-full">

//           {/* TITLE */}
//           <div className="mb-8">
//             <h1 className="text-2xl font-semibold text-[#1E0E62]">
//               Pharmacy Management
//             </h1>
//           </div>
          

//           {/* PHARMACY INFO */}
// <div className="bg-white rounded-2xl shadow-sm p-6 space-y-5 mb-6">

// <div>
//   <h3 className="text-lg font-semibold text-[#1E0E62]">
//     Pharmacy Information
//   </h3>
//   <p className="text-xs text-gray-400">
//     Update pharmacy details and location
//   </p>
// </div>

// <div className="grid md:grid-cols-2 gap-4">

//   {/* NAME */}
//   <InputBase
//     placeholder="Pharmacy Name"
//     value={pharmacy.name || ""}
//     onChange={(e) =>
//       setPharmacy((prev) => ({
//         ...prev,
//         name: e.target.value,
//       }))
//     }
//     className="px-4 py-3 border rounded-xl"
//   />

//   {/* EMAIL */}
//   <InputBase
//     placeholder="Email"
//     value={pharmacy.email || ""}
//     onChange={(e) =>
//       setPharmacy((prev) => ({
//         ...prev,
//         email: e.target.value,
//       }))
//     }
//     className="px-4 py-3 border rounded-xl"
//   />

//   {/* PHONE */}
//   <InputBase
//     placeholder="Phone Number"
//     value={pharmacy.phoneNumber || ""}
//     onChange={(e) =>
//       setPharmacy((prev) => ({
//         ...prev,
//         phoneNumber: e.target.value,
//       }))
//     }
//     className="px-4 py-3 border rounded-xl"
//   />

//   {/* WHATSAPP */}
//   <InputBase
//     placeholder="WhatsApp Number"
//     value={pharmacy.whatsappNumber || ""}
//     onChange={(e) =>
//       setPharmacy((prev) => ({
//         ...prev,
//         whatsappNumber: e.target.value,
//       }))
//     }
//     className="px-4 py-3 border rounded-xl"
//   />

//   {/* ADDRESS (FULL WIDTH) */}
//   <div className="md:col-span-2">
//     <InputBase
//       placeholder="Pharmacy Address"
//       value={pharmacy.location?.address || ""}
//       onChange={(e) =>
//         setPharmacy((prev) => ({
//           ...prev,
//           location: {
//             ...prev.location,
//             address: e.target.value,
//           },
//         }))
//       }
//       className="px-4 py-3 border rounded-xl w-full"
//     />
//   </div>

//   {/* LAT + LNG */}
//   <div className="md:col-span-2 grid grid-cols-2 gap-4">

//     <InputBase
//       placeholder="Latitude"
//       value={pharmacy.location?.lat || ""}
//       onChange={(e) => {
//         const val = e.target.value;
//         if (/^-?\d*\.?\d*$/.test(val)) {
//           setPharmacy((prev) => ({
//             ...prev,
//             location: {
//               ...prev.location,
//               lat: val,
//             },
//           }));
//         }
//       }}
//       className="px-4 py-3 border rounded-xl"
//     />

//     <InputBase
//       placeholder="Longitude"
//       value={pharmacy.location?.lng || ""}
//       onChange={(e) => {
//         const val = e.target.value;
//         if (/^-?\d*\.?\d*$/.test(val)) {
//           setPharmacy((prev) => ({
//             ...prev,
//             location: {
//               ...prev.location,
//               lng: val,
//             },
//           }));
//         }
//       }}
//       className="px-4 py-3 border rounded-xl"
//     />
//   </div>

//   {/* TOOLTIP */}
//   <div className="md:col-span-2 text-xs text-gray-400">
//     Tip: Open Google Maps → right-click your pharmacy → click "What's here?"
//     → copy latitude & longitude.
//   </div>

// </div>
// </div>

//           {/* DRUG FORM */}
//           <div className="bg-white rounded-2xl shadow-sm p-6 space-y-4">

//             <h3 className="text-lg font-semibold">Add Drug</h3>

//             <div className="grid md:grid-cols-2 gap-4">

//               {/* GENERIC */}
//               <div className="relative">
//                 <InputBase
//                   placeholder="Generic Name"
//                   value={drug.genericName}
//                   onFocus={() => setActiveSuggest("generic")}
//                   onChange={(e) =>
//                     setDrug({
//                       ...drug,
//                       genericName: e.target.value.toLowerCase(),
//                     })
//                   }
//                   className="px-4 py-3 border rounded-xl w-full"
//                 />

//                 {activeSuggest === "generic" && (
//                   <div className="absolute bg-white shadow rounded-xl w-full mt-1 z-10">
//                     {getSuggestions(drug.genericName).map((s, i) => (
//                       <div
//                         key={i}
//                         onClick={() => {
//                           setDrug({ ...drug, genericName: s });
//                           setActiveSuggest(null);
//                         }}
//                         className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
//                       >
//                         {s}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* BRAND */}
//               <div className="relative">
//                 <InputBase
//                   placeholder="Brand Name"
//                   value={drug.brandName}
//                   onFocus={() => setActiveSuggest("brand")}
//                   onChange={(e) =>
//                     setDrug({
//                       ...drug,
//                       brandName: e.target.value.toLowerCase(),
//                     })
//                   }
//                   className="px-4 py-3 border rounded-xl w-full"
//                 />

//                 {activeSuggest === "brand" && (
//                   <div className="absolute bg-white shadow rounded-xl w-full mt-1 z-10">
//                     {getSuggestions(drug.brandName).map((s, i) => (
//                       <div
//                         key={i}
//                         onClick={() => {
//                           setDrug({ ...drug, brandName: s });
//                           setActiveSuggest(null);
//                         }}
//                         className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
//                       >
//                         {s}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* TAGS */}
//               <InputBase
//                 placeholder="Tags (comma separated)"
//                 value={drug.tags}
//                 onChange={(e) =>
//                   setDrug({ ...drug, tags: e.target.value })
//                 }
//                 className="px-4 py-3 border rounded-xl"
//               />

//               {/* PRICE */}
//               <InputBase
//                 placeholder="Price (₦)"
//                 value={drug.price}
//                 onChange={(e) =>
//                   setDrug({
//                     ...drug,
//                     price: formatPrice(e.target.value),
//                   })
//                 }
//                 className="px-4 py-3 border rounded-xl"
//               />
//             </div>

//             <button
//               onClick={addDrug}
//               className="bg-gradient-to-r from-[#25DAC5] to-[#1fbfae] text-white px-6 py-3 rounded-xl font-semibold shadow"
//             >
//               Add Drug
//             </button>
//           </div>

//           {/* LIST */}
//           <div className="bg-white rounded-2xl shadow-sm p-6 mt-6 space-y-3">

// {pharmacy.drugs.map((d, i) => {

//   const isEditing = editingIndex === i;

//   return (
//     <div
//       key={i}
//       className="border rounded-xl p-4 space-y-3"
//     >

//       {isEditing ? (
//         <>
//           <div className="grid md:grid-cols-2 gap-3">

//             <InputBase
//               value={editDrug.genericName}
//               onChange={(e) =>
//                 setEditDrug({
//                   ...editDrug,
//                   genericName: e.target.value.toLowerCase(),
//                 })
//               }
//               className="px-3 py-2 border rounded-lg"
//             />

//             <InputBase
//               value={editDrug.brandName}
//               onChange={(e) =>
//                 setEditDrug({
//                   ...editDrug,
//                   brandName: e.target.value.toLowerCase(),
//                 })
//               }
//               className="px-3 py-2 border rounded-lg"
//             />

//             <InputBase
//               value={editDrug.tags}
//               onChange={(e) =>
//                 setEditDrug({ ...editDrug, tags: e.target.value })
//               }
//               className="px-3 py-2 border rounded-lg"
//             />

//             <InputBase
//               value={editDrug.price}
//               onChange={(e) =>
//                 setEditDrug({
//                   ...editDrug,
//                   price: formatPrice(e.target.value),
//                 })
//               }
//               className="px-3 py-2 border rounded-lg"
//             />

//           </div>

//           <div className="flex gap-3">
//             <button
//               onClick={() => updateDrug(d._id)}
//               className="bg-green-500 text-white px-4 py-2 rounded-lg"
//             >
//               Save
//             </button>

//             <button
//               onClick={cancelEdit}
//               className="bg-gray-200 px-4 py-2 rounded-lg"
//             >
//               Cancel
//             </button>
//           </div>
//         </>
//       ) : (
//         <div className="flex justify-between items-center">
//           <div>
//             <p className="font-semibold">
//               {d.genericName} — {d.brandName}
//             </p>
//             <p className="text-xs text-gray-500">
//               {d.tags?.join(", ")}
//             </p>
//           </div>

//           <div className="flex items-center gap-4">

//             <p className="font-semibold">
//               ₦{Number(d.price).toLocaleString()}
//             </p>

//             <button
//               onClick={() => startEdit(d, i)}
//               className="text-blue-600 text-sm"
//             >
//               Edit
//             </button>

//             <button
//               onClick={() => deleteDrug(d._id)}
//               className="text-red-500 text-sm"
//             >
//               Delete
//             </button>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// })}

// </div>

//           {/* SAVE */}
//           <div className="flex justify-center mt-10">
//             <button
//               onClick={handleSave}
//               disabled={loading}
//               className="bg-[#1E0E62] text-white px-10 py-3 rounded-full font-semibold shadow"
//             >
//               {loading ? "Saving..." : "Save Changes"}
//             </button>
//           </div>

//         </main>
//       </div>

//       <DoctorFooter />

//       <SimpleSnackbar message={snackMessage} color={snackColor} />
//     </div>
//   );
// };

// export default PharmacyDashboard;

import React, { useEffect, useMemo, useState } from "react";
import DoctorHeader from "./DoctorHeader";
import DoctorSidebar, { DoctorSidebarDrawer } from "./DoctorSidebar";
import DoctorFooter from "./DoctorFooter";
import { InputBase } from "@mui/material";
import {
  Menu,
  Pill,
  MapPin,
  Phone,
  Mail,
  MessageCircle,
  Plus,
  Save,
  Trash2,
  Edit3,
  X,
  Check,
  Search,
  Building2,
  Loader2,
  Eye,
  FileText,
} from "lucide-react";
import axios from "axios";
import { useParams } from "react-router-dom";
import SimpleSnackbar from "../Snackbar";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const PRESCRIPTION_STATUSES = ["uncosted", "costed", "paid", "delivered"];

const normalizeStatus = (status = "") => {
  if (status === "pending") return "uncosted";
  if (status === "closed") return "delivered";
  return PRESCRIPTION_STATUSES.includes(status) ? status : "uncosted";
};

const statusLabel = (status = "") => {
  const labels = {
    uncosted: "Uncosted",
    costed: "Costed",
    paid: "Paid",
    delivered: "Delivered",
  };

  return labels[normalizeStatus(status)];
};

const statusClass = (status = "") => {
  const classes = {
    uncosted: "bg-amber-50 text-amber-700 border-amber-100",
    costed: "bg-sky-50 text-sky-700 border-sky-100",
    paid: "bg-emerald-50 text-emerald-700 border-emerald-100",
    delivered: "bg-slate-100 text-slate-700 border-slate-200",
  };

  return classes[normalizeStatus(status)] || classes.uncosted;
};

const formatDate = (value) => {
  if (!value) return "No date";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "No date";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const PharmacyDashboard = () => {
  const { pharmId } = useParams();

  const [editingIndex, setEditingIndex] = useState(null);
  const [editDrug, setEditDrug] = useState(null);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pharmacy, setPharmacy] = useState(null);
  const [prescriptions, setPrescriptions] = useState([]);
  const [prescriptionFilter, setPrescriptionFilter] = useState("all");
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [prescriptionDraft, setPrescriptionDraft] = useState(null);
  const [savingPrescription, setSavingPrescription] = useState(false);
  const [sendingEmailId, setSendingEmailId] = useState("");

  const [snackMessage, setSnackMessage] = useState("");
  const [snackColor, setSnackColor] = useState("success");

  const [drug, setDrug] = useState({
    genericName: "",
    brandName: "",
    tags: "",
    price: "",
    description: "",
  });

  const [activeSuggest, setActiveSuggest] = useState(null);
  const [drugSearch, setDrugSearch] = useState("");

  const authHeaders = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };

  const showSnack = (message, color = "success") => {
    setSnackMessage(message);
    setSnackColor(color);
  };

  const fetchPharmacy = async () => {
    try {
      const res = await axios.get(`${API_BASE}/pharmacy/${pharmId}`, {
        headers: authHeaders,
      });

      setPharmacy(res.data.pharmacy);
      setPrescriptions(res.data.prescriptions || []);
    } catch (error) {
      showSnack("Failed to load pharmacy details", "error");
    }
  };

  useEffect(() => {
    fetchPharmacy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pharmId]);

  const formatPrice = (value) => {
    const numeric = String(value || "").replace(/[^\d]/g, "");
    if (!numeric) return "";
    return "₦" + Number(numeric).toLocaleString();
  };

  const parsePrice = (value) => {
    return Number(String(value || "").replace(/[^\d]/g, ""));
  };

  const allDrugNames = useMemo(() => {
    if (!pharmacy?.drugs) return [];

    const names = [];

    pharmacy.drugs.forEach((d) => {
      if (d.genericName) names.push(d.genericName);
      if (d.brandName) names.push(d.brandName);
    });

    return [...new Set(names)];
  }, [pharmacy]);

  const getSuggestions = (value) => {
    if (!value) return [];

    return allDrugNames
      .filter((n) => n.toLowerCase().includes(value.toLowerCase()))
      .slice(0, 5);
  };

  const filteredDrugs = useMemo(() => {
    if (!pharmacy?.drugs) return [];

    const q = drugSearch.trim().toLowerCase();

    if (!q) return pharmacy.drugs;

    return pharmacy.drugs.filter((d) => {
      const generic = d.genericName?.toLowerCase() || "";
      const brand = d.brandName?.toLowerCase() || "";
      const tags = d.tags?.join(" ").toLowerCase() || "";

      return generic.includes(q) || brand.includes(q) || tags.includes(q);
    });
  }, [pharmacy, drugSearch]);

  const prescriptionStats = useMemo(() => {
    return prescriptions.reduce(
      (acc, item) => {
        const status = normalizeStatus(item.status);
        acc.total += 1;
        acc[status] += 1;
        return acc;
      },
      {
        total: 0,
        uncosted: 0,
        costed: 0,
        paid: 0,
        delivered: 0,
      }
    );
  }, [prescriptions]);

  const filteredPrescriptions = useMemo(() => {
    if (prescriptionFilter === "all") return prescriptions;

    return prescriptions.filter(
      (item) => normalizeStatus(item.status) === prescriptionFilter
    );
  }, [prescriptionFilter, prescriptions]);

  const openPrescription = (request) => {
    setSelectedPrescription(request);
    setPrescriptionDraft({
      drugs: (request.drugs || []).map((item) => ({
        name: item.name || "",
        quantity: item.quantity || "",
        price: item.price || "",
      })),
    });
  };

  const closePrescription = () => {
    setSelectedPrescription(null);
    setPrescriptionDraft(null);
  };

  const updatePrescriptionStatus = async (requestId, status) => {
    try {
      showSnack("Updating prescription status...", "info");

      const res = await axios.patch(
        `${API_BASE}/prescriptions/${requestId}/status`,
        { status },
        { headers: authHeaders }
      );

      const nextRequest = res.data?.request;

      setPrescriptions((prev) =>
        prev.map((item) => (item._id === requestId ? nextRequest : item))
      );

      if (selectedPrescription?._id === requestId) {
        setSelectedPrescription(nextRequest);
      }

      showSnack("Prescription status updated", "success");
    } catch (error) {
      console.error(error);
      showSnack(
        error.response?.data?.message || "Failed to update status",
        "error"
      );
    }
  };

  const sendPharmacyEmail = async (requestId) => {
    try {
      setSendingEmailId(requestId);

      await axios.post(
        `${API_BASE}/prescriptions/${requestId}/pharmacy-email`,
        {},
        { headers: authHeaders }
      );

      showSnack("Pharmacy email sent", "success");
    } catch (error) {
      console.error(error);
      showSnack(
        error.response?.data?.message || "Failed to email pharmacy",
        "error"
      );
    } finally {
      setSendingEmailId("");
    }
  };

  const savePrescriptionDraft = async () => {
    if (!selectedPrescription || !prescriptionDraft) return;

    try {
      setSavingPrescription(true);

      const res = await axios.put(
        `${API_BASE}/prescriptions/${selectedPrescription._id}`,
        {
          drugs: prescriptionDraft.drugs,
        },
        { headers: authHeaders }
      );

      const nextRequest = res.data?.request;

      setPrescriptions((prev) =>
        prev.map((item) =>
          item._id === selectedPrescription._id ? nextRequest : item
        )
      );
      setSelectedPrescription(nextRequest);
      setPrescriptionDraft({
        drugs: (nextRequest.drugs || []).map((item) => ({
          name: item.name || "",
          quantity: item.quantity || "",
          price: item.price || "",
        })),
      });

      showSnack("Prescription updated", "success");
    } catch (error) {
      console.error(error);
      showSnack(
        error.response?.data?.message || "Prescription could not be updated",
        "error"
      );
    } finally {
      setSavingPrescription(false);
    }
  };

  const openPhone = (number = "") => {
    if (!number) return;
    window.location.href = `tel:${number}`;
  };

  const openWhatsapp = (number = "") => {
    const clean = String(number || "").replace(/[^\d]/g, "");
    if (!clean) return;
    window.open(`https://wa.me/${clean}`, "_blank", "noopener,noreferrer");
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      showSnack("Saving changes...", "info");

      await axios.put(
        `${API_BASE}/pharmacy/${pharmId}`,
        {
          ...pharmacy,
          location: {
            ...pharmacy.location,
            lat: Number(pharmacy.location?.lat),
            lng: Number(pharmacy.location?.lng),
          },
        },
        {
          headers: authHeaders,
        }
      );

      showSnack("Pharmacy updated successfully", "success");
      fetchPharmacy();
    } catch (error) {
      showSnack("Error updating pharmacy", "error");
    } finally {
      setLoading(false);
    }
  };

  const startEdit = (drugItem, index) => {
    setEditingIndex(index);
    setEditDrug({
      ...drugItem,
      price: "₦" + Number(drugItem.price || 0).toLocaleString(),
      tags: drugItem.tags?.join(", ") || "",
    });
  };

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditDrug(null);
  };

  const updateDrug = async (drugId) => {
    try {
      showSnack("Updating drug...", "info");

      await axios.put(
        `${API_BASE}/pharmacy/${pharmId}/drugs/${drugId}`,
        {
          genericName: editDrug.genericName.toLowerCase(),
          brandName: editDrug.brandName.toLowerCase(),
          tags: editDrug.tags
            .split(",")
            .map((t) => t.trim().toLowerCase())
            .filter(Boolean),
          price: parsePrice(editDrug.price),
          description: editDrug.description,
        },
        {
          headers: authHeaders,
        }
      );

      showSnack("Drug updated successfully", "success");

      cancelEdit();
      fetchPharmacy();
    } catch (error) {
      showSnack("Failed to update drug", "error");
    }
  };

  const deleteDrug = async (drugId) => {
    const confirmed = window.confirm("Delete this drug from the catalog?");

    if (!confirmed) return;

    try {
      showSnack("Removing drug...", "info");

      await axios.delete(`${API_BASE}/pharmacy/${pharmId}/drugs/${drugId}`, {
        headers: authHeaders,
      });

      showSnack("Drug removed successfully", "success");
      fetchPharmacy();
    } catch (error) {
      showSnack("Failed to delete drug", "error");
    }
  };

  const addDrug = async () => {
    if (!drug.genericName || !drug.brandName || !drug.price) {
      showSnack("Generic name, brand name and price are required", "error");
      return;
    }

    try {
      showSnack("Adding drug...", "info");

      await axios.post(
        `${API_BASE}/pharmacy/${pharmId}/drugs`,
        {
          genericName: drug.genericName.toLowerCase(),
          brandName: drug.brandName.toLowerCase(),
          tags: drug.tags
            .split(",")
            .map((t) => t.trim().toLowerCase())
            .filter(Boolean),
          price: parsePrice(drug.price),
          description: drug.description,
        },
        {
          headers: authHeaders,
        }
      );

      showSnack("Drug added successfully", "success");

      setDrug({
        genericName: "",
        brandName: "",
        tags: "",
        price: "",
        description: "",
      });

      fetchPharmacy();
    } catch (error) {
      showSnack("Failed to add drug", "error");
    }
  };

  const updatePharmacyField = (field, value) => {
    setPharmacy((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateLocationField = (field, value) => {
    setPharmacy((prev) => ({
      ...prev,
      location: {
        ...prev.location,
        [field]: value,
      },
    }));
  };

  if (!pharmacy) {
    return (
      <div className="min-h-screen bg-[#F4FBFA] flex items-center justify-center">
        <div className="bg-white/90 border border-[#DDF5F0] shadow-xl rounded-[2rem] px-8 py-7 flex items-center gap-4">
          <Loader2 className="w-6 h-6 text-[#159B8F] animate-spin" />
          <div>
            <p className="font-semibold text-slate-900">Loading pharmacy</p>
            <p className="text-sm text-slate-500">
              Preparing your pharmacy dashboard...
            </p>
          </div>
        </div>
      </div>
    );
  }

  const totalDrugs = pharmacy.drugs?.length || 0;
  const hasLocation = pharmacy.location?.lat && pharmacy.location?.lng;
  const uncostedCount = prescriptionStats.uncosted;
  const activeRequestCount =
    prescriptionStats.uncosted + prescriptionStats.costed + prescriptionStats.paid;

  return (
    <div className="min-h-screen flex flex-col bg-[#F4FBFA] text-slate-950">
      <DoctorHeader />

      <div className="flex flex-1">
        <aside className="hidden lg:flex">
          <DoctorSidebar activeTab="Pharmacy" setActiveTab={() => {}} />
        </aside>

        <DoctorSidebarDrawer
          open={drawerOpen}
          onOpen={() => setDrawerOpen(true)}
          onClose={() => setDrawerOpen(false)}
          activeTab="Pharmacy"
          setActiveTab={() => {}}
        />

        <main className="flex-1 w-full">
          <div className="mx-auto w-full max-w-7xl px-4 py-5 sm:px-6 lg:px-8">
            <div className="mb-6 flex items-center justify-between gap-4 lg:hidden">
              <button
                type="button"
                onClick={() => setDrawerOpen(true)}
                className="inline-flex items-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-semibold text-slate-800 shadow-sm border border-[#DDF5F0]"
              >
                <Menu className="w-5 h-5" />
                Menu
              </button>

              <button
                type="button"
                onClick={handleSave}
                disabled={loading}
                className="inline-flex items-center gap-2 rounded-2xl bg-[#0E7C73] px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-teal-900/10 disabled:opacity-60"
              >
                {loading ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <Save className="w-4 h-4" />
                )}
                Save
              </button>
            </div>

            <section className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-[#062925] via-[#0E7C73] to-[#14B8A6] p-6 sm:p-8 shadow-2xl shadow-teal-950/20">
              <div className="absolute -right-20 -top-24 h-72 w-72 rounded-full bg-white/10 blur-2xl" />
              <div className="absolute -bottom-24 left-20 h-72 w-72 rounded-full bg-[#25DAC5]/20 blur-2xl" />

              <div className="relative z-10 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
                <div>
                  <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white/80">
                    <Pill className="w-4 h-4" />
                    Zaviramed Pharmacy Partner
                  </div>

                  <h1 className="max-w-3xl text-3xl font-black tracking-tight text-white sm:text-4xl lg:text-5xl">
                    Pharmacy Management
                  </h1>

                  <p className="mt-3 max-w-2xl text-sm leading-6 text-white/75 sm:text-base">
                    Manage pharmacy profile, location, drug catalog and pricing
                    for prescription costing and patient fulfillment.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-3 sm:flex">
                  <MetricCard label="Catalog drugs" value={totalDrugs} />
                  <MetricCard label="Uncosted" value={uncostedCount} />
                  <MetricCard
                    label="Active requests"
                    value={activeRequestCount}
                  />
                </div>
              </div>
            </section>

            <div className="mt-6 grid gap-6 xl:grid-cols-[1fr_380px]">
              <section className="space-y-6">
                <Panel
                  icon={<Building2 className="w-5 h-5" />}
                  title="Pharmacy Information"
                  subtitle="Update pharmacy identity, contact details and map coordinates."
                >
                  <div className="grid gap-4 md:grid-cols-2">
                    <FormInput
                      icon={<Building2 className="w-4 h-4" />}
                      placeholder="Pharmacy Name"
                      value={pharmacy.name || ""}
                      onChange={(e) =>
                        updatePharmacyField("name", e.target.value)
                      }
                    />

                    <FormInput
                      icon={<Mail className="w-4 h-4" />}
                      placeholder="Email"
                      value={pharmacy.email || ""}
                      onChange={(e) =>
                        updatePharmacyField("email", e.target.value)
                      }
                    />

                    <FormInput
                      icon={<Phone className="w-4 h-4" />}
                      placeholder="Phone Number"
                      value={pharmacy.phoneNumber || ""}
                      onChange={(e) =>
                        updatePharmacyField("phoneNumber", e.target.value)
                      }
                    />

                    <FormInput
                      icon={<MessageCircle className="w-4 h-4" />}
                      placeholder="WhatsApp Number"
                      value={pharmacy.whatsappNumber || ""}
                      onChange={(e) =>
                        updatePharmacyField("whatsappNumber", e.target.value)
                      }
                    />

                    <div className="md:col-span-2">
                      <FormInput
                        icon={<MapPin className="w-4 h-4" />}
                        placeholder="Pharmacy Address"
                        value={pharmacy.location?.address || ""}
                        onChange={(e) =>
                          updateLocationField("address", e.target.value)
                        }
                      />
                    </div>

                    <FormInput
                      placeholder="Latitude"
                      value={pharmacy.location?.lat || ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^-?\d*\.?\d*$/.test(val)) {
                          updateLocationField("lat", val);
                        }
                      }}
                    />

                    <FormInput
                      placeholder="Longitude"
                      value={pharmacy.location?.lng || ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^-?\d*\.?\d*$/.test(val)) {
                          updateLocationField("lng", val);
                        }
                      }}
                    />

                    <div className="md:col-span-2 rounded-2xl border border-[#DDF5F0] bg-[#F4FBFA] px-4 py-3 text-xs leading-5 text-slate-500">
                      <span className="font-semibold text-slate-700">
                        Tip:
                      </span>{" "}
                      Open Google Maps, right-click your pharmacy, click
                      “What&apos;s here?”, then copy latitude and longitude.
                    </div>
                  </div>
                </Panel>

                <Panel
                  icon={<Plus className="w-5 h-5" />}
                  title="Add Drug"
                  subtitle="Add medication names, tags and prices for costing."
                >
                  <div className="grid gap-4 md:grid-cols-2">
                    <SuggestInput
                      placeholder="Generic Name"
                      value={drug.genericName}
                      active={activeSuggest === "generic"}
                      suggestions={getSuggestions(drug.genericName)}
                      onFocus={() => setActiveSuggest("generic")}
                      onChange={(e) =>
                        setDrug({
                          ...drug,
                          genericName: e.target.value.toLowerCase(),
                        })
                      }
                      onPick={(s) => {
                        setDrug({ ...drug, genericName: s });
                        setActiveSuggest(null);
                      }}
                    />

                    <SuggestInput
                      placeholder="Brand Name"
                      value={drug.brandName}
                      active={activeSuggest === "brand"}
                      suggestions={getSuggestions(drug.brandName)}
                      onFocus={() => setActiveSuggest("brand")}
                      onChange={(e) =>
                        setDrug({
                          ...drug,
                          brandName: e.target.value.toLowerCase(),
                        })
                      }
                      onPick={(s) => {
                        setDrug({ ...drug, brandName: s });
                        setActiveSuggest(null);
                      }}
                    />

                    <FormInput
                      placeholder="Tags e.g. malaria, pain, antibiotics"
                      value={drug.tags}
                      onChange={(e) =>
                        setDrug({ ...drug, tags: e.target.value })
                      }
                    />

                    <FormInput
                      placeholder="Price (₦)"
                      value={drug.price}
                      onChange={(e) =>
                        setDrug({
                          ...drug,
                          price: formatPrice(e.target.value),
                        })
                      }
                    />

                    <div className="md:col-span-2">
                      <InputBase
                        multiline
                        minRows={3}
                        placeholder="Short description or notes"
                        value={drug.description}
                        onChange={(e) =>
                          setDrug({ ...drug, description: e.target.value })
                        }
                        className="w-full rounded-2xl border border-[#D8ECE8] bg-white px-4 py-3 text-sm text-slate-900 transition focus-within:border-[#14B8A6] focus-within:ring-4 focus-within:ring-[#14B8A6]/10"
                      />
                    </div>
                  </div>

                  <div className="mt-5 flex justify-end">
                    <button
                      type="button"
                      onClick={addDrug}
                      className="inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-[#0E7C73] to-[#14B8A6] px-6 py-3 text-sm font-bold text-white shadow-xl shadow-teal-900/10 transition hover:scale-[1.01] active:scale-[0.99]"
                    >
                      <Plus className="w-4 h-4" />
                      Add Drug
                    </button>
                  </div>
                </Panel>
              </section>

              <aside className="space-y-6">
                <div className="rounded-[2rem] border border-[#DDF5F0] bg-white/90 p-5 shadow-xl shadow-slate-900/5 backdrop-blur">
                  <div className="mb-4 flex items-center justify-between">
                    <div>
                      <h3 className="text-base font-black text-slate-950">
                        Pharmacy Summary
                      </h3>
                      <p className="text-xs text-slate-500">
                        Quick operational details
                      </p>
                    </div>

                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#E7FAF6] text-[#0E7C73]">
                      <Pill className="w-5 h-5" />
                    </div>
                  </div>

                  <div className="space-y-3">
                    <InfoRow label="Name" value={pharmacy.name || "Not set"} />
                    <InfoRow
                      label="Phone"
                      value={pharmacy.phoneNumber || "Not set"}
                    />
                    <InfoRow
                      label="WhatsApp"
                      value={pharmacy.whatsappNumber || "Not set"}
                    />
                    <InfoRow
                      label="Drugs"
                      value={`${totalDrugs} catalog item${
                        totalDrugs === 1 ? "" : "s"
                      }`}
                    />
                    <InfoRow
                      label="Branches"
                      value={`${pharmacy.branches?.length || 0} branch${
                        (pharmacy.branches?.length || 0) === 1 ? "" : "es"
                      }`}
                    />
                    <InfoRow
                      label="Map"
                      value={hasLocation ? "Coordinates set" : "Not set"}
                    />
                  </div>

                  <button
                    type="button"
                    onClick={handleSave}
                    disabled={loading}
                    className="mt-5 hidden w-full items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 py-3 text-sm font-bold text-white shadow-xl shadow-slate-950/10 transition hover:bg-[#0E7C73] disabled:opacity-60 lg:inline-flex"
                  >
                    {loading ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      <Save className="w-4 h-4" />
                    )}
                    {loading ? "Saving..." : "Save Changes"}
                  </button>
                </div>
              </aside>
            </div>

            <section className="mt-6 rounded-[2rem] border border-[#DDF5F0] bg-white/90 p-4 shadow-xl shadow-slate-900/5 backdrop-blur sm:p-6">
              <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                <div>
                  <div className="inline-flex items-center gap-2 rounded-full bg-[#E7FAF6] px-3 py-1 text-xs font-bold text-[#0E7C73]">
                    <FileText className="h-4 w-4" />
                    Prescription requests
                  </div>

                  <h2 className="mt-2 text-xl font-black text-slate-950">
                    Prescriptions sent to this pharmacy
                  </h2>

                  <p className="text-sm text-slate-500">
                    Track costing, payment and delivery from one place.
                  </p>
                </div>

                <div className="flex flex-wrap gap-2">
                  {["all", ...PRESCRIPTION_STATUSES].map((status) => (
                    <button
                      key={status}
                      type="button"
                      onClick={() => setPrescriptionFilter(status)}
                      className={`rounded-xl border px-3 py-2 text-xs font-bold capitalize transition ${
                        prescriptionFilter === status
                          ? "border-slate-950 bg-slate-950 text-white"
                          : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
                      }`}
                    >
                      {status === "all" ? "All" : statusLabel(status)}
                    </button>
                  ))}
                </div>
              </div>

              <div className="mb-5 grid grid-cols-2 gap-3 md:grid-cols-5">
                <StatusCount label="All" value={prescriptionStats.total} />
                <StatusCount label="Uncosted" value={prescriptionStats.uncosted} />
                <StatusCount label="Costed" value={prescriptionStats.costed} />
                <StatusCount label="Paid" value={prescriptionStats.paid} />
                <StatusCount label="Delivered" value={prescriptionStats.delivered} />
              </div>

              {filteredPrescriptions.length === 0 ? (
                <div className="rounded-[1.5rem] border border-dashed border-[#BFEAE2] bg-[#F4FBFA] p-8 text-center">
                  <h3 className="font-bold text-slate-950">
                    No prescriptions here yet
                  </h3>
                  <p className="mt-1 text-sm text-slate-500">
                    Prescriptions sent for costing will appear here.
                  </p>
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full min-w-[980px] text-left text-sm">
                    <thead>
                      <tr className="border-b border-[#DDF5F0] text-xs uppercase tracking-wide text-slate-400">
                        <th className="py-3 font-bold">Prescription ID</th>
                        <th className="py-3 font-bold">Date</th>
                        <th className="py-3 font-bold">Patient</th>
                        <th className="py-3 font-bold">Status</th>
                        <th className="py-3 font-bold">Total</th>
                        <th className="py-3 font-bold">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredPrescriptions.map((request) => {
                        const status = normalizeStatus(request.status);
                        const patient = request.patientId || {};

                        return (
                          <tr
                            key={request._id}
                            className="border-b border-[#EFF8F6] text-slate-700"
                          >
                            <td className="py-3">
                              <button
                                type="button"
                                onClick={() => openPrescription(request)}
                                className="font-bold text-slate-950 hover:underline"
                              >
                                {String(request._id).slice(-8)}
                              </button>
                              <p className="mt-1 text-xs text-slate-400">
                                {request.drugs?.length || 0} medicine
                                {(request.drugs?.length || 0) === 1 ? "" : "s"}
                              </p>
                            </td>
                            <td className="py-3">{formatDate(request.createdAt)}</td>
                            <td className="py-3">
                              <p className="font-semibold text-slate-950">
                                {patient.name || "Patient"}
                              </p>
                              <p className="text-xs text-slate-400">
                                {patient.phoneNumber || patient.email || "No contact"}
                              </p>
                            </td>
                            <td className="py-3">
                              <select
                                value={status}
                                onChange={(event) =>
                                  updatePrescriptionStatus(
                                    request._id,
                                    event.target.value
                                  )
                                }
                                className={`rounded-xl border px-3 py-2 text-xs font-bold outline-none ${statusClass(
                                  status
                                )}`}
                              >
                                {PRESCRIPTION_STATUSES.map((item) => (
                                  <option key={item} value={item}>
                                    {statusLabel(item)}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td className="py-3 font-bold text-slate-950">
                              ₦{Number(request.totalCost || 0).toLocaleString()}
                            </td>
                            <td className="py-3">
                              <div className="flex flex-wrap gap-2">
                                <ActionButton onClick={() => openPrescription(request)}>
                                  <Eye className="h-4 w-4" />
                                  View
                                </ActionButton>
                                <ActionButton
                                  onClick={() => sendPharmacyEmail(request._id)}
                                  disabled={sendingEmailId === request._id}
                                >
                                  {sendingEmailId === request._id ? (
                                    <Loader2 className="h-4 w-4 animate-spin" />
                                  ) : (
                                    <Mail className="h-4 w-4" />
                                  )}
                                  Email
                                </ActionButton>
                                <ActionButton
                                  onClick={() => openPhone(pharmacy.phoneNumber)}
                                >
                                  <Phone className="h-4 w-4" />
                                  Call
                                </ActionButton>
                                <ActionButton
                                  onClick={() =>
                                    openWhatsapp(
                                      pharmacy.whatsappNumber || pharmacy.phoneNumber
                                    )
                                  }
                                >
                                  <MessageCircle className="h-4 w-4" />
                                  WhatsApp
                                </ActionButton>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </section>

            <section className="mt-6 rounded-[2rem] border border-[#DDF5F0] bg-white/90 p-4 shadow-xl shadow-slate-900/5 backdrop-blur sm:p-6">
              <div className="mb-5 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div>
                  <div className="inline-flex items-center gap-2 rounded-full bg-[#E7FAF6] px-3 py-1 text-xs font-bold text-[#0E7C73]">
                    <Pill className="w-4 h-4" />
                    Drug Catalog
                  </div>

                  <h2 className="mt-2 text-xl font-black text-slate-950">
                    Available Drugs
                  </h2>

                  <p className="text-sm text-slate-500">
                    Edit prices, update tags or remove unavailable drugs.
                  </p>
                </div>

                <div className="relative w-full md:max-w-sm">
                  <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                  <input
                    value={drugSearch}
                    onChange={(e) => setDrugSearch(e.target.value)}
                    placeholder="Search drug catalog..."
                    className="w-full rounded-2xl border border-[#D8ECE8] bg-white py-3 pl-11 pr-4 text-sm outline-none transition focus:border-[#14B8A6] focus:ring-4 focus:ring-[#14B8A6]/10"
                  />
                </div>
              </div>

              {filteredDrugs.length === 0 ? (
                <div className="rounded-[1.5rem] border border-dashed border-[#BFEAE2] bg-[#F4FBFA] p-8 text-center">
                  <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-[#0E7C73] shadow-sm">
                    <Pill className="w-6 h-6" />
                  </div>
                  <h3 className="font-bold text-slate-950">No drugs found</h3>
                  <p className="mt-1 text-sm text-slate-500">
                    Add a drug above or adjust your search term.
                  </p>
                </div>
              ) : (
                <div className="grid gap-3">
                  {filteredDrugs.map((d) => {
                    const originalIndex = pharmacy.drugs.findIndex(
                      (item) => item._id === d._id
                    );

                    const isEditing = editingIndex === originalIndex;

                    return (
                      <div
                        key={d._id || originalIndex}
                        className="rounded-[1.5rem] border border-[#E3F3F0] bg-white p-4 transition hover:border-[#BFEAE2] hover:shadow-lg hover:shadow-slate-900/5"
                      >
                        {isEditing ? (
                          <div className="space-y-4">
                            <div className="grid gap-3 md:grid-cols-2">
                              <FormInput
                                value={editDrug.genericName}
                                onChange={(e) =>
                                  setEditDrug({
                                    ...editDrug,
                                    genericName:
                                      e.target.value.toLowerCase(),
                                  })
                                }
                              />

                              <FormInput
                                value={editDrug.brandName}
                                onChange={(e) =>
                                  setEditDrug({
                                    ...editDrug,
                                    brandName: e.target.value.toLowerCase(),
                                  })
                                }
                              />

                              <FormInput
                                value={editDrug.tags}
                                onChange={(e) =>
                                  setEditDrug({
                                    ...editDrug,
                                    tags: e.target.value,
                                  })
                                }
                              />

                              <FormInput
                                value={editDrug.price}
                                onChange={(e) =>
                                  setEditDrug({
                                    ...editDrug,
                                    price: formatPrice(e.target.value),
                                  })
                                }
                              />
                            </div>

                            <div className="flex flex-wrap gap-3">
                              <button
                                type="button"
                                onClick={() => updateDrug(d._id)}
                                className="inline-flex items-center gap-2 rounded-2xl bg-[#0E7C73] px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-teal-900/10"
                              >
                                <Check className="w-4 h-4" />
                                Save
                              </button>

                              <button
                                type="button"
                                onClick={cancelEdit}
                                className="inline-flex items-center gap-2 rounded-2xl bg-slate-100 px-5 py-2.5 text-sm font-bold text-slate-700"
                              >
                                <X className="w-4 h-4" />
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                            <div className="flex items-start gap-4">
                              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#E7FAF6] text-[#0E7C73]">
                                <Pill className="w-5 h-5" />
                              </div>

                              <div>
                                <h3 className="font-black capitalize text-slate-950">
                                  {d.genericName || "Unnamed drug"}
                                  {d.brandName ? (
                                    <span className="font-semibold text-slate-500">
                                      {" "}
                                      — {d.brandName}
                                    </span>
                                  ) : null}
                                </h3>

                                <div className="mt-2 flex flex-wrap gap-2">
                                  {d.tags?.length ? (
                                    d.tags.map((tag, index) => (
                                      <span
                                        key={`${tag}-${index}`}
                                        className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600"
                                      >
                                        {tag}
                                      </span>
                                    ))
                                  ) : (
                                    <span className="text-xs text-slate-400">
                                      No tags
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="flex items-center justify-between gap-4 md:justify-end">
                              <p className="rounded-2xl bg-[#FFF8E1] px-4 py-2 text-base font-black text-slate-950">
                                ₦{Number(d.price || 0).toLocaleString()}
                              </p>

                              <div className="flex items-center gap-2">
                                <button
                                  type="button"
                                  onClick={() => startEdit(d, originalIndex)}
                                  className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-100 text-slate-700 transition hover:bg-[#E7FAF6] hover:text-[#0E7C73]"
                                  title="Edit drug"
                                >
                                  <Edit3 className="w-4 h-4" />
                                </button>

                                <button
                                  type="button"
                                  onClick={() => deleteDrug(d._id)}
                                  className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-red-50 text-red-500 transition hover:bg-red-500 hover:text-white"
                                  title="Delete drug"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </section>
          </div>
        </main>
      </div>

      {selectedPrescription && (
        <PrescriptionRequestModal
          request={selectedPrescription}
          draft={prescriptionDraft}
          setDraft={setPrescriptionDraft}
          onClose={closePrescription}
          onSave={savePrescriptionDraft}
          saving={savingPrescription}
        />
      )}


      <SimpleSnackbar message={snackMessage} color={snackColor} />
    </div>
  );
};

const MetricCard = ({ label, value }) => {
  return (
    <div className="rounded-3xl border border-white/15 bg-white/10 px-5 py-4 text-white backdrop-blur">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/60">
        {label}
      </p>
      <p className="mt-1 text-2xl font-black">{value}</p>
    </div>
  );
};

const Panel = ({ icon, title, subtitle, children }) => {
  return (
    <section className="rounded-[2rem] border border-[#DDF5F0] bg-white/90 p-4 shadow-xl shadow-slate-900/5 backdrop-blur sm:p-6">
      <div className="mb-5 flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#E7FAF6] text-[#0E7C73]">
          {icon}
        </div>

        <div>
          <h2 className="text-lg font-black text-slate-950">{title}</h2>
          <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
        </div>
      </div>

      {children}
    </section>
  );
};

const FormInput = ({ icon, className = "", ...props }) => {
  return (
    <div
      className={`flex items-center gap-3 rounded-2xl border border-[#D8ECE8] bg-white px-4 py-3 transition focus-within:border-[#14B8A6] focus-within:ring-4 focus-within:ring-[#14B8A6]/10 ${className}`}
    >
      {icon ? <span className="text-slate-400">{icon}</span> : null}

      <InputBase
        {...props}
        className="w-full text-sm text-slate-900"
        inputProps={{
          className: "placeholder:text-slate-400",
          ...(props.inputProps || {}),
        }}
      />
    </div>
  );
};

const SuggestInput = ({
  value,
  placeholder,
  onFocus,
  onChange,
  active,
  suggestions,
  onPick,
}) => {
  return (
    <div className="relative">
      <FormInput
        placeholder={placeholder}
        value={value}
        onFocus={onFocus}
        onChange={onChange}
      />

      {active && suggestions.length > 0 && (
        <div className="absolute left-0 right-0 z-20 mt-2 overflow-hidden rounded-2xl border border-[#DDF5F0] bg-white shadow-2xl shadow-slate-900/10">
          {suggestions.map((s, i) => (
            <button
              type="button"
              key={`${s}-${i}`}
              onClick={() => onPick(s)}
              className="block w-full px-4 py-3 text-left text-sm font-semibold capitalize text-slate-700 transition hover:bg-[#F4FBFA] hover:text-[#0E7C73]"
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const InfoRow = ({ label, value }) => {
  return (
    <div className="flex items-start justify-between gap-4 rounded-2xl bg-[#F8FCFB] px-4 py-3">
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
        {label}
      </p>
      <p className="text-right text-sm font-bold text-slate-800">{value}</p>
    </div>
  );
};

const StatusCount = ({ label, value }) => (
  <div className="rounded-2xl border border-[#DDF5F0] bg-[#F8FCFB] p-4">
    <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
      {label}
    </p>
    <p className="mt-2 text-2xl font-black text-slate-950">
      {Number(value || 0).toLocaleString()}
    </p>
  </div>
);

const ActionButton = ({ children, disabled, ...props }) => (
  <button
    type="button"
    disabled={disabled}
    className="inline-flex h-9 items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3 text-xs font-bold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
    {...props}
  >
    {children}
  </button>
);

const PrescriptionRequestModal = ({
  request,
  draft,
  setDraft,
  onClose,
  onSave,
  saving,
}) => {
  const status = normalizeStatus(request.status);
  const editable = status === "uncosted";
  const patient = request.patientId || {};
  const doctor = request.doctorId || {};

  const updateDrug = (index, key, value) => {
    setDraft((prev) => ({
      ...prev,
      drugs: (prev?.drugs || []).map((item, itemIndex) =>
        itemIndex === index ? { ...item, [key]: value } : item
      ),
    }));
  };

  const addDrug = () => {
    setDraft((prev) => ({
      ...prev,
      drugs: [...(prev?.drugs || []), { name: "", quantity: "1", price: "" }],
    }));
  };

  const removeDrug = (index) => {
    setDraft((prev) => ({
      ...prev,
      drugs: (prev?.drugs || []).filter((_, itemIndex) => itemIndex !== index),
    }));
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-end bg-slate-950/50 p-3 sm:items-center sm:justify-center sm:p-6">
      <section className="max-h-[92vh] w-full max-w-3xl overflow-hidden rounded-[2rem] bg-white shadow-2xl">
        <div className="flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
              Prescription ID {String(request._id).slice(-8)}
            </p>
            <h2 className="mt-1 text-lg font-black text-slate-950">
              Prescription request
            </h2>
            <p className="mt-1 text-sm text-slate-500">
              {patient.name || "Patient"} · {formatDate(request.createdAt)} ·{" "}
              {statusLabel(status)}
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-slate-200 text-slate-500 hover:bg-slate-50"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="max-h-[calc(92vh-150px)] overflow-y-auto p-5">
          <div className="grid gap-3 sm:grid-cols-2">
            <InfoRow label="Patient" value={patient.name || "N/A"} />
            <InfoRow label="Doctor" value={doctor.name || "N/A"} />
            <InfoRow label="Status" value={statusLabel(status)} />
            <InfoRow
              label="Total"
              value={`₦${Number(request.totalCost || 0).toLocaleString()}`}
            />
          </div>

          <div className="mt-5">
            <div className="mb-3 flex items-center justify-between gap-3">
              <h3 className="text-sm font-black text-slate-950">Medicines</h3>
              {editable && (
                <button
                  type="button"
                  onClick={addDrug}
                  className="rounded-xl border border-slate-200 px-3 py-2 text-xs font-bold text-slate-700 hover:bg-slate-50"
                >
                  Add medicine
                </button>
              )}
            </div>

            <div className="space-y-3">
              {(draft?.drugs || []).map((drug, index) => (
                <div
                  key={`${drug.name}-${index}`}
                  className="grid gap-2 rounded-2xl border border-slate-200 bg-slate-50 p-3 md:grid-cols-[1fr_120px_120px_auto]"
                >
                  <input
                    disabled={!editable}
                    value={drug.name || ""}
                    onChange={(event) =>
                      updateDrug(index, "name", event.target.value)
                    }
                    placeholder="Medicine"
                    className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm outline-none disabled:bg-slate-100"
                  />
                  <input
                    disabled={!editable}
                    value={drug.quantity || ""}
                    onChange={(event) =>
                      updateDrug(index, "quantity", event.target.value)
                    }
                    placeholder="Qty"
                    className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm outline-none disabled:bg-slate-100"
                  />
                  <input
                    disabled
                    value={drug.price ? `₦${Number(drug.price).toLocaleString()}` : ""}
                    placeholder="Price"
                    className="rounded-xl border border-slate-200 bg-slate-100 px-3 py-2 text-sm outline-none"
                  />
                  {editable && (
                    <button
                      type="button"
                      onClick={() => removeDrug(index)}
                      className="rounded-xl bg-red-50 px-3 py-2 text-xs font-bold text-red-600 hover:bg-red-100"
                    >
                      Remove
                    </button>
                  )}
                </div>
              ))}
            </div>

            {!editable && (
              <p className="mt-3 rounded-2xl bg-amber-50 p-3 text-sm text-amber-800">
                This prescription has been costed, so the medicine list is
                locked.
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 border-t border-slate-200 px-5 py-4">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-slate-200 px-4 py-2 text-sm font-bold text-slate-700 hover:bg-slate-50"
          >
            Close
          </button>

          {editable && (
            <button
              type="button"
              onClick={onSave}
              disabled={saving}
              className="inline-flex items-center gap-2 rounded-xl bg-slate-950 px-4 py-2 text-sm font-bold text-white disabled:opacity-60"
            >
              {saving && <Loader2 className="h-4 w-4 animate-spin" />}
              Save prescription
            </button>
          )}
        </div>
      </section>
    </div>
  );
};

export default PharmacyDashboard;
